module.exports = __webpack_public_path__ + "static/media/40-4.fd04c33b.mp3";